import { render, staticRenderFns } from "./program-record-main.vue?vue&type=template&id=78fe5b0a&lang=pug&"
import script from "./program-record-main.vue?vue&type=script&lang=js&"
export * from "./program-record-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports